import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getIncoTermList(params) {
  return request({
    url: URL.mdm.basicData.incoTerm,
    method: 'get',
    params
  })
}

export function getIncoTermsByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformIncoTerm,
    method: 'get',
    params
  })
}

export function getAllIncoTermTemplate(params) {
  return request({
    url: URL.mdm.basicData.incoTermTemplate,
    method: 'get',
    params
  })
}

export function saveIncoTerm(data) {
  return request({
    url: URL.mdm.basicData.incoTerm,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function addIncoTermByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformIncoTerm,
    method: 'post',
    data
  })
}

export function saveIncoTerms(data) {
  return request({
    url: URL.mdm.basicData.incoTerms,
    method: 'post',
    data
  })
}

export function delIncoTerm(uuid) {
  return request({
    url: URL.mdm.basicData.incoTerm + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
